import { render } from "./SimpleHeader.vue?vue&type=template&id=419d3e52&scoped=true"
const script = {}

import "./SimpleHeader.vue?vue&type=style&index=0&id=419d3e52&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419d3e52"]])

export default __exports__